module.exports = __webpack_public_path__ + "8ec266a4a664adc9ad6b2751728725bd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/red.png
// module id = 2757
// module chunks = 0